<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-tabelapreco') {
            next({ name: 'ven-tabelapreco-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-tabelapreco') {
            this.$router.push({ name: 'ven-tabelapreco-list' });
        }
    },
};
</script>
